define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi",
	"csi/action/Controller",
	"csi/locale",
	"csi/xml",
	"csi/xml/Query"
], function(declare,_,csi,Controller,locale,xml,Query) {

	return declare([Controller], {

		_getFixedFilters: function() {
			var q = new Query();

			var queryResult = this.widget.getQueryResultByDomNode(this.m_element);
			if (queryResult) {
				var groupParents = queryResult.getGroupParents();
				if (groupParents) {
					groupParents.every(function(result, index) {
						var gs = result.level.groupSpec
						var groupId = gs.heading.m_id;

						if (groupId == "DSSection") {
							q.RefAttr("DSSection", xml.OP_EQUALS, result.groupValue);
							return false;
						}

						return true;
					}, this);
				}
			}
			return q.getElements();
		},

		/**
		 * Sets current PartMaterials that are under this assembly as already selected and grayed out
		 * @return {FormData} Returns the FormData with the function that finds the PartMaterials in the assembly
		 */
		getFormData: function() {
			if (this.m_formData) {
				return this.m_formData;
			}

			var fd = this.inherited(arguments);
			fd.m_fAggregateTest = this._isExistingPartMaterial;

			return fd;
		},

		/**
		 * Function that gets the list of PartMaterials under the assembly, selects the checkbox
		 * and disables the selection
		 * @param {Context} ctx - context of the table
		 * @param {FormData} fd - FormData of the table
		 * @return {Boolean} returns false if it is a PartMaterial under the assembly
		 */
		_isExistingPartMaterial: function(/*Context*/ctx, /*FormData*/fd) {
			var node = this.getNode();
			var materialBOM = ctx.cache.getNode(node.BOMLineBOM);
			var currRev = ctx.cache.getNode(materialBOM.CurrentRevision);
			var items = currRev.Items;

			if (_.contains(items, ctx.getNode().$URL)) {
				fd.addAggregatedNode(ctx.getNode());
				return false;
			} else {
				return true;
			}
		}
	});
});